export default class AppConst {
	/**
	 * Community Talk トークルームのHTMLタグ名
	 */
	static readonly COMMUNITY_TALK_TAG = "revico-community-talk";
	/**
	 * Community Talk 投稿数>共通要素のHTMLタグ名
	 */
	static readonly COMMUNITY_TALK_POST_COUNT_COMMON_TAG = "revico-community-talk-post-count-common";
	/**
	 * Community Talk 投稿数のHTMLタグ名
	 */
	static readonly COMMUNITY_TALK_POST_COUNT_TAG = "revico-community-talk-post-count";
	/**
	 * Community Talk 投稿一覧のHTMLタグ名
	 */
	static readonly COMMUNITY_TALK_POST_LIST_TAG = "revico-community-talk-post-list";

	/**
	 * 議題名を取得するhiddenタグのID名。
	 */
	static readonly SUBJECT_NAME_HIDDEN_ID = "hidden_revico_subjectname";

	/**
	 * トークルーム内容の投稿最大文字長。
	 */
	static readonly TALKROOM_CONTENTS_MAX_LENGTH = 1000;

	/**
	 * リプライ内容の投稿最大文字長。
	 */
	static readonly REPLY_CONTENTS_MAX_LENGTH = 1000;

	/**
	 * ユーザー>ニックネームの投稿最大文字長。
	 */
	static readonly COMMUNITY_TALK_USER_NICKNAME_MAX_LENGTH = 50;

	/**
	 * リプライプロフィール画像のデフォルト画像。
	 */
	static readonly PROFILE_PIC_DEFAULT_IMAGE = `${process.env.VUE_APP_REVICO_FRONT_ENDPOINT}/community_talk/user/profile_pic/00000000-0000-0000-0000-000000000000.jpg`;

	/**
	 * 表示用トークルームIDを取得するhiddenタグのID名。
	 */
	static readonly DISPLAY_TALK_ROOM_ID_HIDDEN_ID = "hidden_display_talkroom_id";

	/**
	 * LocalStorageのKey群。
	 */
	static readonly LOCALSTORAGE_KEYS = {
		REPLY_POST_NICKNAME: "replyPostNickname",
		COMMUNITY_TALK_USER_NICKNAME: "communityUserNickname",
		REPLY_POST_REVIEWER_ATTRIBUTES: "replyPostReviewerAttributes",
		COMMUNITY_TALK_USER_REVIEWER_ATTRIBUTES: "communityUserReviewerAttributes",
		REPLY_POST_PROFILE_PICTURE: "replyPostProfilePicture",
		COMMUNITY_TALK_USER_PROFILE_PICTURE: "communityUserProfilePicture",
	};
}
